/**
 * Scrolls the first visible form error into view and focuses the related control.
 */

const isVisible = (el: HTMLElement): boolean => {
  const style = getComputedStyle(el)
  const rect = el.getBoundingClientRect()

  return (
    style.visibility !== 'hidden' &&
    style.display !== 'none' &&
    rect.height > 0 &&
    rect.width > 0
  )
}

const INTERACTIVE_SELECTOR =
  'input, textarea, select, button, [role="combobox"], [contenteditable="true"], [tabindex]:not([tabindex="-1"])'

const findFirstVisibleError = (scope: ParentNode): HTMLElement | null => {
  const errorElements = scope.querySelectorAll<HTMLElement>(
    '.form-helper-text_error',
  )
  for (const el of errorElements) {
    if (isVisible(el)) {
      return el
    }
  }

  return null
}

export const marketplacePartnerRegisterPageFormScrollToFirstFormError = (
  root: HTMLElement,
): void => {
  const errorEl = findFirstVisibleError(root)
  if (!errorEl) {
    return
  }

  // Try a reasonable container, then  scroll to it
  const container: HTMLElement = errorEl.parentElement ?? errorEl

  container.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest',
  })

  // Focus first reasonable interactive element within the container; fallback to error element
  const focusTarget: HTMLElement =
    container.querySelector<HTMLElement>(INTERACTIVE_SELECTOR) ?? errorEl
  requestAnimationFrame(() => {
    try {
      focusTarget.focus({ preventScroll: true })
    } catch {
      // Ignore - focusing non-interactive elements can throw in some browsers
    }
  })
}
